import React from "react";
import logo from "./logocolor.svg";

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-sky-100 via-white to-sky-50 text-gray-900">
      {/* Header */}
      <header className="flex justify-center py-10">
        <img
          src={logo}
          alt="Sehgal Tech Logo"
          className="w-28 h-28 animate-float drop-shadow-lg"
        />
      </header>

      {/* Hero Section */}
      <main className="flex flex-col items-center text-center px-6">
        <h1 className="text-5xl font-extrabold mb-4 bg-gradient-to-r from-blue-600 to-sky-500 bg-clip-text text-transparent">
          Welcome to Sehgal Tech
        </h1>
        <p className="text-lg text-gray-700 max-w-2xl">
          We craft scalable, intelligent, and sustainable web solutions —
          blending creativity, innovation, and technology to empower your ideas.
        </p>
      </main>

      {/* PigB Showcase */}
      <section className="mt-20 flex flex-col items-center px-6">
        <div className="bg-white p-8 rounded-2xl shadow-xl max-w-2xl text-center border border-blue-100">
          <div className="flex flex-col items-center">
            <img
              src="/pigb-logo.svg"
              alt="PigB Logo"
              className="w-28 h-28 mb-4"
            />
            <h2 className="text-3xl font-bold mb-3 text-blue-700">
              Featured Project: PigB
            </h2>
            <p className="text-gray-600 mb-6">
              <strong>PigB</strong> is a next-generation{" "}
              <strong>Finance Management App</strong> by Sehgal Tech. Track
              expenses, manage savings, and stay in control of your finances —
              all through a powerful and intuitive dashboard.
            </p>
            <a
              href="https://pigb.sehgaltech.com/"
              target="_blank"
              rel="noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-full shadow-md transition-transform transform hover:scale-105"
            >
              Visit PigB App
            </a>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="mt-20 flex flex-col items-center px-6">
        <div className="bg-white p-10 rounded-2xl shadow-xl max-w-3xl text-center border border-blue-100">
          <h2 className="text-3xl font-bold mb-4 text-blue-700">
            📝 Sehgal Tech Blog
          </h2>
          <p className="text-gray-600 mb-6 max-w-xl mx-auto">
            Stay updated with the latest insights, tutorials, and engineering
            stories from Sehgal Tech. Learn about web development, AI, finance
            tech, and product building — directly from the team that builds it.
          </p>
          <a
            href="https://blog.sehgaltech.com/"
            target="_blank"
            rel="noreferrer"
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-full shadow-md transition-transform transform hover:scale-105"
          >
            Visit Sehgal Tech Blog
          </a>
        </div>
      </section>

      {/* Social Links */}
      <footer className="mt-24 mb-10 flex flex-col items-center space-y-4">
        <p className="text-gray-700 font-medium">Connect with Sehgal Tech</p>
        <div className="flex space-x-6">
          <a
            href="https://www.instagram.com/devmadesimple/"
            target="_blank"
            rel="noreferrer"
            className="hover:text-blue-500 transition-colors"
          >
            <i className="fa-brands fa-instagram text-2xl"></i>
          </a>
          <a
            href="https://www.facebook.com/devmadesimple"
            target="_blank"
            rel="noreferrer"
            className="hover:text-blue-600 transition-colors"
          >
            <i className="fa-brands fa-facebook text-2xl"></i>
          </a>
          <a
            href="https://www.youtube.com/channel/UCVCTuszyIFFKepdubSl0cRw"
            target="_blank"
            rel="noreferrer"
            className="hover:text-red-500 transition-colors"
          >
            <i className="fa-brands fa-youtube text-2xl"></i>
          </a>
        </div>

        <p className="text-sm text-gray-500 mt-6">
          © {new Date().getFullYear()} Sehgal Tech. Built with 💙 by Purvi Sehgal & Sayuj Sehgal.
        </p>
      </footer>
    </div>
  );
}

export default App;
